import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseModel } from 'src/app/models/response-model';
import { environment } from 'src/environments/environment';
import { CustomEncoder } from '../@core/encoders/custom-encoder';
import { ComboSet } from '../models/set';

@Injectable({
  providedIn: 'root',
})
export class SetsService {
  private url = `${environment.url}/sets`;
  constructor(private http: HttpClient) { }

  readSetByCodeAndBranch(
    code: string,
    branchCode: string
  ): Observable<ResponseModel<Array<ComboSet>>> {
    let params = new HttpParams({ encoder: new CustomEncoder() });

    params = params.set('code', code).set('branchCode', branchCode);

    return this.http.get<ResponseModel<Array<ComboSet>>>(this.url, { params });
  }
}
